'use strict';

const internals = {};


module.exports = class {
    constructor(key, path, parent, reference) {

        this.key = key;
        this.path = path;
        this.parent = parent;
        this.reference = reference;
    }
};



// WEBPACK FOOTER //
// ./node_modules/@hapi/joi/lib/types/state.js